<template lang="pug">
  div.context-node
    module-title(title="危机脉络")
    div.venations
      div.venation(v-for="venation in venations" :key="venation.name")
        p.title(v-if="venation.nodes.length") {{venation.name}}
        div.node(v-for="(node, i) in venation.nodes" :key="i")
          div.time
            div.time_p
              p.hour {{node.hour}}
              p.day {{node.day}}
          div.radius
          div.context
            span.firstTag(v-if="node.isFirst") 首发
            span.organization 【{{node.organization}}】
            a(:href="node.url" target="_blank" v-if="node.url") {{node.content}}
            span.content(v-else) {{node.content}}
            i.fa.fa-picture-o(v-if="node.img" @click.prevent="viewImg(node)")
    img-viewer(v-if="showImg" @close="showImg = false" :img="img")
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import ImgViewer from '../components/ImgViewer'
import client from '../server/server'
import moment from 'moment'
import { venationsConfig, parseUrl } from '../config/config'
export default {
  name: 'ContextNode',
  components: {
    ModuleTitle,
    ImgViewer
  },
  data () {
    return {
      venations: [],
      img: '',
      showImg: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventVenation(params)
        .then(res => {
          if (res.success) {
            this.venations = [
              {
                name: '上升期',
                nodes: res.data.lurk.map(d => {
                  return Object.assign({}, d, {
                    hour: moment(d.publishTime).format('HH时'),
                    day: moment(d.publishTime).format('YYYY-MM-DD'),
                    organization: venationsConfig[d.organization],
                    url: parseUrl(d.url),
                    img: d.img ? this.$imgParse(d.img) : d.img
                  })
                })
              },
              {
                name: '热议期',
                nodes: res.data.hot.map(d => {
                  return Object.assign({}, d, {
                    hour: moment(d.publishTime).format('HH时'),
                    day: moment(d.publishTime).format('YYYY-MM-DD'),
                    organization: venationsConfig[d.organization],
                    url: parseUrl(d.url),
                    img: d.img ? this.$imgParse(d.img) : d.img
                  })
                })
              },
              {
                name: '衰退期',
                nodes: res.data.recession.map(d => {
                  return Object.assign({}, d, {
                    hour: moment(d.publishTime).format('HH时'),
                    day: moment(d.publishTime).format('YYYY-MM-DD'),
                    organization: venationsConfig[d.organization],
                    url: parseUrl(d.url),
                    img: d.img ? this.$imgParse(d.img) : d.img
                  })
                })
              }
            ]
          }
        })
    },
    viewImg (n) {
      this.showImg = true
      this.img = n.img
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";
  .context-node{
    flex: 1;
    height: 660px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-left: 20px;
    padding: 14px;
    .venations{
      color: #666;
      height: 600px;
      overflow-y: auto;
      margin-top: 20px;
      @include scrollBar;
      .venation{
        .title{
          margin: 8px 0 8px 90px;
          color: #f87653;
          transform: translate(-21px, 0);
        }
        .node{
          display: flex;
          align-items: center;
          position: relative;
          .time{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 90px;
            min-height: 60px;
            border-right: 1px solid #eee;
            font-size: 12px;
            .time_p{
              text-align: right;
              margin-right: 10px;
            }
          }
          .radius{
            width: 8px;
            height: 8px;
            background-color: #ffffff;
            border: solid 1px #eeeeee;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 90px;
            transform: translate(-50%, -50%);
            z-index: 2;
          }
          .context{
            margin: 0 20px;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            font-size: 14px;
            /*overflow: hidden;*/
            /*-webkit-box-orient: vertical;*/
            /*-webkit-line-clamp: 2;*/

            .firstTag{
              display: inline-block;
              width: 60px;
              height: 25px;
              line-height: 25px;
              color: #fff;
              background-color: #E67C5B;
              border-radius: 2px;
              text-align: center;
              font-size: 12px;
            }
            .organization{
              color: #333;
              font-weight: bold;
            }
            i{
              margin-left: 5px;
              color: #999;
              &:hover{
                color: #3989cb;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/ContextNode.vue